<template>
    <div class="timeline-item">
        <img :src="picto" alt="Picto timeline" class="timeline-item__picto" />
        <h3 class="timeline-item__title">
            {{ title }}
        </h3>
        <div class="timeline-item__body" v-html="body"></div>
        <div class="timeline-item__logo-container">
            <img v-if="logo !== ''" :src="logo" alt="Logo intersport" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TimelineItem',

        props: {
            picto: {
                type:    String,
                default: '',
            },
            title: {
                type:    String,
                default: '',
            },
            body: {
                type:    String,
                default: '',
            },
            logo: {
                type:    String,
                default: '',
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_mixins';

    .timeline-item{
        position: relative;

        display: flex;
        flex-direction: column;
        align-items: flex-start;

        width: 180px;
        padding: 40px 30px;

        text-align: left;

        border-left: 2px solid #3b3b3c;

        &::after{
            content: '';
            position: absolute;
            left: -21px;
            top: 50%;

            width: 39px;
            height: 39px;

            background-image: url(../../assets/images/about/bullet-point.png);
            background-size: cover;

            transform: translateY(-50%);
        }

        @include media-breakpoint-up(sm) {
            align-items: center;

            margin-bottom: 40px;
            padding: 40px 10px;

            border-left: none;
            border-bottom: 2px solid #3b3b3c;

            text-align: center;

            &::before{
                content: '';
                position: absolute;
                top: 100px;
                left: 0;
                width: 100%;
                height: 1px;
                background-color: #3b3b3c;
            }

            &::after{
                top: auto;
                bottom: -21px;
                left: 50%;

                transform: translateX(-50%);
            }
        }

        @include media-breakpoint-up(md) {
            flex: 1 0 auto;

        }

        @include media-breakpoint-up(lg) {
            padding: 20px 10px 40px;

            &::before{
                top: 80px;
            }
        }

        &__picto{
            position: relative;
            width: 120px;
            height: 110px;
        }

        &__title{
            margin: 0;

            @extend %font-OpenSans-bold;
            font-size: 32px;
            line-height: normal;
            color: $gray-600;
        }

        &__body{
            flex: 1 0 auto;

            margin: 8px 0 20px;

            @extend %font-OpenSans-regular;
            font-size: 14px;
            line-height: normal;
            color: $gray-600;
        }

        &__logo-container{
            flex: 0 0 72px;
            display: flex;
            align-items: center;
        }

        &__logo{
            width: auto;
        }
    }
</style>
